import { render, staticRenderFns } from "./FullscreenLoader.vue?vue&type=template&id=65b1820e&scoped=true&"
import script from "./FullscreenLoader.vue?vue&type=script&lang=js&"
export * from "./FullscreenLoader.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenLoader.vue?vue&type=style&index=0&id=65b1820e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1820e",
  null
  
)

export default component.exports